import { render, staticRenderFns } from "./AddressInputs.vue?vue&type=template&id=0c395bac&scoped=true&lang=pug&"
import script from "./AddressInputs.vue?vue&type=script&lang=js&"
export * from "./AddressInputs.vue?vue&type=script&lang=js&"
import style0 from "./AddressInputs.vue?vue&type=style&index=0&id=0c395bac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c395bac",
  null
  
)

/* custom blocks */
import block0 from "./AddressInputs.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
